import type { AnalyticsProvider } from "../types";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

function pushToDataLayer(data: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  (window.dataLayer ??= []).push(data);
}

export const gtmProvider: AnalyticsProvider = {
  name: "gtm",
  track: (event, properties) => pushToDataLayer({ event, ...properties }),
  identify: (userId, traits) => {
    pushToDataLayer({
      event: "user_properties_set",
      user_id: userId,
      user_properties: { user_id: userId, ...traits },
    });
  },
  reset: () => {
    pushToDataLayer({
      event: "user_properties_set",
      user_id: null,
      user_properties: {},
    });
  },
};
